module.exports = __webpack_public_path__ + "img/39_25.c072c75b.png";